import { Pipe, PipeTransform } from '@angular/core'
import { cpf } from 'cpf-cnpj-validator'


@Pipe({
    name: 'formatDocumentNumber',
    standalone: false
})
export class FormatDocumentNumberPipe implements PipeTransform {
  public transform(value?: string | null): string {
    if (!value) {
      return ''
    }

    const isCPF = value.length <= 11
    return isCPF ? cpf.format(value) : this.formatCnpj(value)
  }

  public formatCnpj(value: string): string {
    const cleaned = value
      .toUpperCase()
      .replaceAll(/[^\dA-Z]/g, '')
      .slice(0, 14)

    const p1 = cleaned.slice(0, 2)
    const p2 = cleaned.slice(2, 5)
    const p3 = cleaned.slice(5, 8)
    const p4 = cleaned.slice(8, 12)
    const p5 = cleaned.slice(12, 14)

    let result = p1

    if (p2) result += '.' + p2
    if (p3) result += '.' + p3
    if (p4) result += '/' + p4
    if (p5) result += '-' + p5

    return result
  }
}
